import React from 'react';
import { Role } from '../../consts';
import { Site } from '../../lib/Site';
import { GlobalNavStateAndHelpers } from '../GlobalNav/GlobalNav';
import { NavigationDrawer } from '../NavigationDrawer/NavigationDrawer';
import OffCanvasPrimary from '../OffCanvasPrimary/OffCanvasPrimary';
import OffCanvasUser from '../OffCanvasUser/OffCanvasUser';

export interface GlobalNavDrawersProps {
    site: Site;
    role: Role;
}

export default class GlobalNavDrawers extends React.Component<
    GlobalNavDrawersProps & GlobalNavStateAndHelpers
> {
    render() {
        return (
            <React.Fragment>
                <NavigationDrawer
                    isOpen={this.props.drawerState.left}
                    direction="left"
                    toggleDrawer={this.props.toggleDrawer}
                >
                    <OffCanvasPrimary role={this.props.role} site={this.props.site} />
                </NavigationDrawer>
                <NavigationDrawer
                    isOpen={this.props.drawerState.right}
                    direction="right"
                    toggleDrawer={this.props.toggleDrawer}
                >
                    <OffCanvasUser role={this.props.role} />
                </NavigationDrawer>
            </React.Fragment>
        );
    }
}
